// Uses global Swiper from vendor-swiper.js (must load before this file)
const getSwiper = () => window.Swiper;
const getScrollbarModule = () => window.SwiperModules?.Scrollbar;

function waitForSwiper(maxAttempts = 80) {
  return new Promise((resolve) => {
    let attempts = 0;
    const check = () => {
      if (getSwiper() && getScrollbarModule()) {
        resolve(true);
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        resolve(false);
        return;
      }
      setTimeout(check, 50);
    };
    check();
  });
}

/**
 * Collection / resource-list carousels (homepage collection list, etc.)
 */
export async function initResourceCarousel() {
  const ready = await waitForSwiper();
  if (!ready) return null;

  const Swiper = getSwiper();
  const Scrollbar = getScrollbarModule();

  const containers = document.querySelectorAll(
    '.zone3-resource-carousel.swiper:not([data-swiper-initialized])'
  );

  containers.forEach((container) => {
    if (!(container instanceof HTMLElement)) return;

    const scrollbarEl = container.querySelector('.zone3-resource-carousel__scrollbar');
    const gap = parseInt(container.dataset.columnGap || '16', 10);
    const slideCount = parseInt(container.dataset.slideCount || '0', 10);

    try {
      const swiper = new Swiper(container, {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        spaceBetween: gap,
        grabCursor: true,
        watchOverflow: false,
        scrollbar:
          scrollbarEl && slideCount > 1
            ? {
                el: scrollbarEl,
                draggable: true,
                snapOnRelease: true,
              }
            : undefined,
      });

      container.setAttribute('data-swiper-initialized', 'true');

      const prev = container.querySelector('.slideshow-control--previous');
      const next = container.querySelector('.slideshow-control--next');

      prev?.addEventListener('click', (event) => {
        event.preventDefault();
        swiper.slidePrev();
      });

      next?.addEventListener('click', (event) => {
        event.preventDefault();
        swiper.slideNext();
      });
    } catch (error) {
      console.error('[zone3-resource-carousel] Swiper init failed:', error);
    }
  });

  return Promise.resolve(true);
}

function boot() {
  initResourceCarousel();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
